module.exports = __webpack_public_path__ + "img/barber.4473e492.svg";